<template>
    <FlowDownAuditRequestView 
		:preview="preview" 
		:previewID="previewID == 0 ? parseInt(this.$route.params.id) : previewID"
		:submitterName="submitterName"
	></FlowDownAuditRequestView>
</template>

<script>
import FlowDownAuditRequestView from "./FlowDownAuditRequestView.vue"
export default {
	name: "FlowDownTemplatePreview",
	components: {
		FlowDownAuditRequestView
	},
	props: {
		preview: {
			type: Boolean,
			default: true,
		},
		previewID: {
			type: Number,
			default: 0,
		},
		submitterName: {
			type: String,
			default: null
		}
	},
}
</script>